import { render, staticRenderFns } from "./phone-number-input.component.vue?vue&type=template&id=206b78e6&scoped=true"
import script from "./phone-number-input.component.ts?vue&type=script&lang=ts&external"
export * from "./phone-number-input.component.ts?vue&type=script&lang=ts&external"
import style0 from "./phone-number-input.component.vue?vue&type=style&index=0&id=206b78e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206b78e6",
  null
  
)

export default component.exports